module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "ch02"
    }
  }), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('strong', [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("IT WASNT FAR")]), _vm._v(" to Flo’s place. I took Fruitville to the Trail, then down to Siesta Drive, made a right, crossed Osprey, and then took a left into Flo Zink’s driveway just before the bridge to Siesta Key. I would have preferred to keep going to the beach and just sit on a bench watching the gulls and pelicans.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was a small black Toyota in the circular driveway. The white minivan wasn’t there. Flo had lost her license twice in Florida for DUI violations. She hadn’t hurt anyone, but that wasn’t the point and she knew it. Flo had her license back but seldom drove even when ice-clear sober and when she did drive it was the white minivan.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The door was opened before I had a chance to knock.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Flo stood there, denim skirt, blue and red checkerboard shirt, and a glass in her hand. Her hair was white, cut short, and looking frizzy. Flo reminded me of Thelma Ritter, even looked a little like the actress. I told her that once. Her answer had been, “Gus always said I looked like Greer Garson.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Behind Flo I could hear her stereo blasting from the "), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _vm._v("speakers throughout the house. All she played was country and western music, most of it from decades ago. She liked Roy Acuff, Roy Rogers, and The Sons of the Pioneers. Patsy Cline was, however, her favorite and it was Patsy in the background wailing, “If you loved me half as much as I love you …”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let’s get it out of the way before you come in,” she said. “I’ve been drinking. I plan to stop again when you find Adele and bring her home.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Can I come in?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She stepped back and lifted her arm. I stepped in.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Patsy sang, “… you wouldn’t do half the things you do.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Can we turn the music down?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why not?” Flo said, leading me into the large living room and heading for the stereo against the wall. She turned a knob and Patsy faded into the background.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Adele worked this out,” she said. “Set up this Internet music thing, found a radio station in Fort Worth that plays my music, and figured out how to pipe it through the stereo. Adele is smart.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Flo took a drink and pressed her lips together.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Flo’s home, a large sprawling one-story building with no exterior beauty but a great view of Sarasota Bay, was decorated in early Clint Eastwood. The furniture was ranch western and lots of Stickney. There were Navajo rugs on the wood floors and Hopi blankets on the sofas and chairs. Aside from the rugs and blankets, Flo’s house was dark wood and simple furniture. On the table in the center of the room between a sofa and two chairs sat a genuine Remington of a cowboy on a rearing horse. A stag head with massive antlers looked down at us from one wall.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I sat in one of the chairs. Flo sat on the sofa, one arm draped over the back, the other holding the drink that she looked at from time to time to be sure it existed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You want a drink?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ve already had a beer this morning,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her eyebrows went up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Careful there, sad eyes,” she said. “Beer can lead to all sorts of things. Let’s get to it. Adele’s gone, took the van. She’s … what happened to your face?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Someone hit me,” I said with a small smile to suggest that such things happen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I served her papers.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Slap the messenger,” she said with an understanding tilt of her head. “You hit her back?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I didn’t answer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Give me her name and I’ll go kick her ass for you,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She’s big,” I said. “And kicking her ass won’t make me feel better. Flo, why am I here?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“To find Adele,” she said. “I told you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you sure she ran away?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Drove, been gone three days. Took the van. Left a note. Here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She reached into the pocket of her flannel shirt, pulled out a sheet of paper, and handed it to me. It was double folded. I opened it and read: “Flo, I don’t know if I’m coming back. I’ll pay you for the van when I have the money or I’ll return it. There’s something I’ve got to do. I’ll call. You know I love you.” It was signed “Adios, Adele.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe she couldn’t take me acting like a mother. I don’t think so. She seemed to like it. Maybe she ran away with Mickey what’s-his-name, works at the Burger King right over there on the Trail. She’s been seeing him. But I’m betting on Conrad Lonsberg.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The writer?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not many other people around here named Conrad Lonsberg, are there?” she said, working on her drink. “Yes, the great Conrad Lonsberg.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She held up her glass to drink to the name. There wasn’t much left to drink.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I knew Lonsberg had a place in Sarasota. He was seldom seen and never attended any literary parties or gave talks or went to the Sarasota Reading Festival. Once in a long while his photograph would appear in a big magazine, "), _c('em', [_vm._v("People, Vanity Fair")]), _vm._v(", places like that. But there was never much text.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I had read his classic "), _c('em', [_vm._v("Fool’s Love")]), _vm._v(" when I was about seventeen. I guess almost everyone had read it. It was now over forty years old and still selling along with his two collections of short stories, mostly reprints from the series he did for "), _c('em', [_vm._v("The New Yorker")]), _vm._v(", and his second novel, "), _c('em', [_vm._v("Plugged Nickels")]), _vm._v(", which had stayed on the "), _c('em', [_vm._v("New York Times")]), _vm._v(" bestseller list for one hundred twenty weeks. "), _c('em', [_vm._v("Plugged Nickels")]), _vm._v(" came out in 1978. That was the year his wife died. And that was it. I seemed to remember that Lonsberg had moved from someplace east, I think Connecticut, to Sarasota. He had two children, a son and daughter. He gave no interviews, allowed no photographs of his children. Seemed to have no friends and made it clear he wanted minimal contact with the world. Lonsberg was a Sarasota legend. People reported Lonsberg sightings along with Stephen King, Monica Selles, and Jerry Springer glimpses.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I sympathized, empathized, sometimes envied Lonsberg’s decision. I didn’t remember "), _c('em', [_vm._v("Fool’s Love")]), _vm._v(" very well. It was a short novel about a teenage girl from a small town who leaves home and heads across the country to live with her aunt who has a supposedly wild lifestyle. The girl meets all kinds of people on the way and when she finally gets to her aunt finds that the aunt is basically no different from the mother she left behind.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Lonsberg?” I prompted Flo who was looking up at the stag head.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Remember when Adele got that story published?” she asked. “First prize, right in "), _c('em', [_vm._v("City Tempo")]), _vm._v(". Her picture in the newspaper.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I remember,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The story had basically been autobiographical, loose ends tied together by fiction and the names of all the characters changed. I was in the story, sort of. There was a detective hired by the girl’s mother to find her. The detective’s name was Milo Loomis. He was big, tough, and had a sense of humor. No one would recognize me in Milo, but it wasn’t hard to spot her central character, Joan, as Adele. The story was honest. Joan wasn’t spared her responsibility for the things that had happened to her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Lonsberg read the story,” said Flo. “A few days after "), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _vm._v("the magazine came out, he called, gave me his name, asked if I was Adele’s mother. Tell you the truth, I didn’t know who the hell Conrad Lonsberg was, but Adele did. She’s been great, Lew. These months … her grades went up. She pretty much stayed home though she worked on the school paper. She started going with this Mickey kid. Seemed okay. Friendly. Things were going great. Then this Lonsberg calls. I sort of remembered the name, I think. He asked if he could talk to Adele. Adele was shaking when she took the phone. Anyway, Lonsberg told Adele that he had read her story and would like to meet her. She stood there holding the phone waiting for me to give her permission.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And you did?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Adele’s picture had been in the paper, remember? She had been interviewed by Channel 40. Adele is one beautiful sixteen-year-old. But then again I seemed to remember Lonsberg was an old guy, older than yours truly Florence Ornstein Zink.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She drank to that too.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So,” she went on, “seemed okay to me and I figured from the look she had that she would probably see him even if I said ‘no,’ but thanks for asking, I thought.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They set up a time the next day after school,” Flo went on. “He gave his address on Casey Key, north end. I drove her down, a thick folder full of her stories and poems in her lap. You know that big stone wall on the north end of the Casey?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Which one?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The one out toward the water. White stone walls maybe nine feet high?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think I know the place. That’s where Lonsberg lives?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s where,” she said, looking at her now-empty glass. “Adele rang a bell. Few minutes later the gate was opened and she went in.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Wasn’t invited,” she said, getting up with a sigh. “Sat in the van reading something. I can’t remember what. Sat for about an hour. I was thinking of ringing the bell when she came out, all excited. Lonsberg wanted to work with her, wanted her to come every Saturday morning. So, that’s "), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _vm._v("what we did. She told me he was a nice old man. I know about nice old men. Old men are still men. So, every Saturday we drove to Casey Key and I sat in the car reading. Son of a bitch never invited me in, never so much as came over to the car and introduced himself. I kept asking Adele if he tried to get in her pants or touch her. She said he didn’t Went on like this for five or six months, then six weeks ago Saturday she came out, got in the car, and said, ‘Let’s get away from here.’ We got away. She was mad as a cougar with an arrow in his ass and she was shaking. Adele’s been through a lot we both know about, and she can handle herself. She wasn’t handling herself after that visit. She wouldn’t talk about it. And she never went back to Lonsberg’s place. A couple of days later she started going out with this kid Mickey, the one from Burger King, almost every night. I saw some of the old Adele coming back. Smart-ass talk, schoolwork just barely getting done. She stopped writing and I think she was making it with this Mickey.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So something happened at Lonsberg’s that day and she’s run away with Mickey,” I summarized as Flo went to the wooden liquor cabinet to pour herself another drink.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Lonsberg called last week,” she said, bottle in hand closing the cabinet door. “Adele talked to him for maybe thirty seconds, mostly she listened and then at the end said ‘yes’ and slammed down the phone.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Flo brought her bottle to the sofa and poured herself another drink, putting the bottle on the table in front of the Remington horse.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She tell you what the call was about?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Nope,” said Flo, taking a drink. “Not a word. Then, like a fast fart from a buffalo, she leaves a note and takes off.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll find her,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Good,” Flo said, toasting.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Does Sally know?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Flo shook her head “no.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sally Porovsky was a social worker with Children’s Services of Sarasota. Adele was one of her cases. I was also seeing Sally and her two kids from time to time. In a way, Adele had brought us together.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll let her know,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She’ll call in the cops,” said Flo. “They’ll find her, put her someplace. They won’t let her come back here. I’m one tough old bitch, Fonesca, but I need that girl back here and I think she needs me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll be careful,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll write you a check,” she said, putting down her glass and starting to rise.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She looked at me, closed her eyes, and shook her head in understanding.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But I do want two things.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Name ‘em,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I want to look at Adele’s room and I want you to stop drinking.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My drinking is none of your fuckin’ business,” she said, now standing over me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Back on the wagon or I tell Sally this isn’t the place for her.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You little pope-loving wop son of a bitch,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m immune to flattery, and besides, I’m Episcopalian,” I said. “Flo, the wagon’s making its rounds. Climb in.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“God’s truth,” said Flo, sagging, “I don’t know if I can.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You can,” I said. “You want Adele back?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, shit,” she said, putting down the half-full glass in her hand. “How about beer? Two a day, no more.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Deal,” I said, getting up and holding out my hand. She took it and held on.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sorry what I said,” she said softly. “I was wrong to call you…”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I can live with it,” I said, still holding her hand.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Find her for me, Lew,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now there were definitely tears.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll find her, Flo. Let’s take a look at her room.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Flo led me down a corridor, past closed doors to an open one. It was clearly a girl’s room. Brightly colored. Flowered comforter. Stereo in the corner. A few stuffed animals. A desk and bookcase and posters on the walls, four of them, three of recent rock idols with blaring colors and one small "), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _vm._v("one in black and white of a woman from another time and place.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who’s that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The woman? Willa Cather. Adele says she was a great writer, wanted to be like her.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Anything missing?” I asked, moving to the clean, clear desk.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A stuffed penguin is all I’m sure of,” Flo said, looking around. “And clothes. She took clothes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One of Lonsberg’s books was on the shelf along with a collection of classics we all claim to have read in school but never did or don’t really remember. The Lonsberg book, a paperback, was a bit battered from frequent readings. I opened it to the title page. In a scrawl I had trouble reading was a note in ink: “Adele, you have the talent. Don’t lose it. Don’t compromise.” It was signed. I couldn’t read the name but I could make out the “C” and the “L” at the beginning of each name. It was an autographed first paperback edition.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mind if I take this?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Take what you need,” Flo said. “I don’t read that stuff. Louis L’Amour and a few others, Frank Roderus, that’s what I read. Lew, I kept hoping she’d just come back but…”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was no diary, no journal, no short stories or notes by Adele in her desk, drawers, bookshelf, or closet. Flo walked me back through the house giving me directions to Lonsberg’s house.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You have Lonsberg’s phone number?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No,” she said. “Come to think of it I don’t think Adele did either. She never called him. He always called her.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I touched her shoulder at the door. She gave me a weak smile of courage and out I went. Before I reached the Cutlass, the voice of Tex Ritter blasted through the Zinc house singing of lost dogies.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When I got in the car, I reached for "), _c('em', [_vm._v("Fool’s Love")]), _vm._v(" and flipped it open. Every page was covered with thick black Magic Marker lines. Adele had put in a lot of work making this book unreadable.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I drove away with twenty minutes to make it ‘til my "), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _vm._v("appointment with Ann Horowitz. I found a two-hour parking spot across from Sarasota News & Books. A new crowded upscale Italian restaurant had just opened across the street from the bookstore at the corner of Main and Palm. Parking didn’t come easy and two-hour parking meant two-hour parking or a ticket.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I found a pay phone and called Harvey the computer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Haven’t had time yet,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not calling about Vera Lynn Uliaks,” I said. “I need an unlisted phone number.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“When?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Now,” I said, holding my hand over my ear to blur the sound of a couple in their fifties doing battle as they headed in the general direction of the library.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay,” said Harvey.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t put me on hold,” I said. “I can’t take the music.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Name?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Conrad Lonsberg,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He doesn’t have a phone,” said Harvey. “That’s an easy one. Tycinker wanted to reach him a few months back about some case. No phone. I can give you an address.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ve got one. Harve, what do you think about AA?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pause and then. “They can help,” he said. “It’s like a religion if it works. I tried it, needed too much support, went cold on my own. So far so good. Why are you asking?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ve got a friend,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Good luck. Talk to you tomorrow.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He hung up and I checked my watch. I had five minutes, just enough time to stop at Sarasota News & Books, pick up two coffees and a biscotti. I paid Ann Horowitz twenty dollars a visit when I could afford it, ten when I couldn’t, and always brought her coffee and a chocolate biscotti.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She was just around the corner on Gulf Stream, a small office with a small waiting room. Ann had no secretary and a select few patients. At the age of eighty-one and with her annuity from Stanford University plus investments she had mentioned from time to time plus the money her husband Melvin still brought in as a successful sculptor, Ann could have retired two decades earlier. But therapy was what she "), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _vm._v("did and enjoyed in addition to conversation, history, odd facts, coffee, biscotti, and opera. Ann and Melvin had chosen Sarasota because their only son lived here with his wife and two grown daughters.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ann’s inner door was open. I could hear her talking. From the pauses, I figured she was on the phone so I moved to the doorway where she motioned for me to take my usual seat across from her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ann is a small woman with a tolerant smile. She likes bright dresses. Her hair is gray, straight, and short enough to show off her colorful earrings.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No,” she told the person on the phone, “I’ll see you at four… no, you will not kill yourself… I understand… four. Did you read the book?… I gave you a book, "), _c('em', [_vm._v("Lost Horizon")]), _vm._v("… No, I did not want you to rent the movie. I wanted you to read the book… You’ve got a few hours. Start reading.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She hung up the phone and accepted the coffee and biscotti from me, placing both on the desk to her right, and looked at me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I knew what she was looking at.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I got slapped by a woman I was serving papers,” I explained as she examined the side of my face.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And what did you do?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“In response to being slapped. What did you do?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I got on my bike and left.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ann shook her head.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What should I have done?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Getting on your bicycle is one thing. Getting angry is another. Saying something to the woman.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I wasn’t angry,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You should have been. You should let yourself feel, but don’t worry. I’m not commanding you to feel. It doesn’t work that way. Here, take this with you,” she said, handing me a copy of "), _c('em', [_vm._v("Smithsonian")]), _vm._v(" magazine. “Article in there about gargoyles. Fascinating.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I took the magazine. There was a grinning stone gargoyle on the cover, just the right gift for a depressed client. Ann "), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _vm._v("took the lid off the cup of black coffee and dipped the biscotti.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Can you do it today?” she asked, looking at me as she lifted the saturated biscotti to her mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not today,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She wanted me to speak the name of my wife. I had done it only twice since she had died, once to Sally and two weeks ago when I managed to say it to Ann. Saying her name aloud had brought back images, memories, pain, the empty feeling in my stomach, the sound of my heart madly pulsing blood through my veins, my neck, my head.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Feel better?” Ann asked when I had said my wife’s name.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No,” I answered. “Worse. Much worse.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course,” she said. “This is therapy, not magic.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I had gone through this opening session ritual four times since then with Ann asking me to speak the name aloud. I had managed it only that one session.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Can you do it?” Ann asked, biscotti in hand.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I took a deep breath, felt the beat of my heart, closed my eyes, and softly uttered, “Catherine.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And you feel how?” Ann asked, redipping her biscotti.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sorry I said it,” I said, reaching for my own coffee, which unlike my therapist’s was strongly fortified with half and half and two packets of Equal.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course you are. You are still in love with your depression and self-pity. You’ve held it around you like a child’s comfort blanket since your wife died. If you give it up, what are you left with?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’ve been through this,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And each week we become different people,” she said. “Sometimes different people with different answers. This time you said her name.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Without my depression,” I said. “The few times anxiety takes over. I shake. I can’t do anything. I walk till I’m exhausted. Even "), _c('em', [_vm._v("Mildred Pierce")]), _vm._v(" doesn’t help. I think… you know all this.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You would rather be depressed than anxious,” she said, continuing to work on my burnt offering.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Is that a question or an observation?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _vm._v("“Your choice.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, I would rather be depressed,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You owe it to Catherine to live depressed and guilty. You want to hide, not feel and slowly die, a hermit, a saint who does not deserve life.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m just recapitulating,” she said. “Do they have flavors other than chocolate?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Next time if you remember, bring almond or something,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll do that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Change is good, small stimulation from small changes. I just segued from my own taste to a metaphoric reference to your state of mind.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I noticed,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You were meant to. You wouldn’t be one of my favorite clients if you couldn’t follow what I say.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I thought I was your favorite,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You are part of an elite group.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Am I making progress?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you want to make progress?” she asked in return.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Good question.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You still seeing Sally?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, tonight. Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You can turn in your blanket of depression for something else,” she said. “Like coming back to life with a real person.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not giving up my wife,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You said her name,” Ann said with a smile, pointing her finger at me. “Progress. I’m not asking you to give her up. I’m asking you to place her gently inside you where she belongs and go on with your life.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I shook my head and said, “We keep saying the same things.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But in different ways and… tell me, Lewis, are you starting to feel different?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And it makes you anxious?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _vm._v("“Angry.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“At who? Who are you angry with?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Say something about her,” Ann said, leaning back.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Your wife. Did she do anything that annoyed you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I closed my eyes, and shook my head “no.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She was perfect,” Ann said. “Nobody’s perfect. Remember the last line of "), _c('em', [_vm._v("Some Like It Hot")]), _vm._v("? When Joe B. Brown finds out Jack Lemmon isn’t a woman? ‘Nobody’s perfect,’ he says.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She left doors and drawers open,” I said. “Medicine cabinet, kitchen cabinets, dresser drawers. All the time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And what did you do?” Ann prompted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I closed them.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Never got irritated?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“For a while. Then …”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You liked her having little faults?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I guess,” I said. “I think I can remember everything in those cabinets and drawers.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you want to remember them?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No … yes. This isn’t fun.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s not supposed to be fun. You don’t know how to have fun yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ann stood up and jogged in place a few seconds.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Knee tightens,” she said, sitting again. “You showed me her photograph. She was pretty.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I nodded, seriously considering never coming back here again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Lewis, you are not pretty.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know. We … she picked me. We had …”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Fun?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A lot in common,” I said. “Movies, books. We found the same things funny. Monty Python, Thin Man movies, Rocky and Bullwinkle.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Moose and squirrel,” Ann said in a terrible imitation of either Natasha or Boris. “What?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Something must have broken through. I bit my lower lip.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sometimes she called me Rocky,” I said. “If I was being "), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _vm._v("particularly dense, she called me Bullwinkle. I… I called her… No more.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ann clapped her hands and rocked forward once.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Perfect. Are you still going to the beach?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“When I can.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And the gulls, do you still hear them speak?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Gulls don’t speak,” I said. “Sometimes their squawk … I’ve told you this… Sometimes their talk sounds like they’re saying, ‘It’s me.’”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You like the gulls?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And the pelicans?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And the pelicans who dive like clumsy-winged oafs into the Gulf literally going blind from the constant collision with the water in search of food.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You are getting very literary, very poetic,” said Ann.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“As my friend Flo would say, ‘Bullshit.’”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You are the gull crying, ‘It’s me.’ You are the pelican going blind while it dives for food.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m literary. You’re cryptic.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We went on like that for a while. I glanced at the clock on the wall over her desk. Five more minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You ever read Conrad Lonsberg?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes,” she said. “Compelling, disturbing, elevating. Isn’t that what the reviews said? All true but there was a true despair behind those poems and stories. I met him once, briefly, here in Sarasota. I recognized him from the old photograph on the jacket of "), _c('em', [_vm._v("Fool’s Love")]), _vm._v(". He was more than forty years older than the man in the photograph leaning against a tree with his hands in his pockets. But the eyes were the same. I remember. Our eyes met. It was at Demitrio’s on the Trail. Melvin and I were there. Lonsberg was with a young woman. Our eyes met for an instant and he knew I recognized him. I think I smiled to let him know his secret was safe and I would not bother him. I wonder if he has had any therapy. Judging from his books, I would say it would be a good idea as long as he didn’t go to one of the quacks with shingles. Why the interest in Conrad Lonsberg?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Remember Adele?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _vm._v("“Vividly,” said Ann. “There is a connection between this evocation of Conrad Lonsberg and Adele? It is not a simple stream of consciousness, a seeming non sequitur?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You want to tell me what you are talking about or, rather, what you want to ask me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Too long to tell the whole story,” I said, looking at the clock on the wall. “Our time is just about up and I hear your next client coming through the outer door.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Give me the question,” Ann said. “In your eyes, you have a question.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why would Adele, who Lonsberg has been working with, deface her copy of one of his books and not just tear it up or throw it away?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You want a two-minute answer, which is the time we have left?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What I want and what I get are almost never the same,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She is angry with him, very angry, feels betrayed, but can’t bring herself to throw away the book. Something is unfinished. Something went very wrong. In that which we call reality. In the reality of Adele’s mind. Lewis, I would need more information. Ideally, I would need Lonsberg and Adele together in this room. I think that unlikely. Meanwhile, I’ll end with a question. Why did you leap the chasm of thought from being angry with me and identifying with seagulls to Adele and Lonsberg?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Next time,” she said, rising. “Think about it. Come with an answer.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll try.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s an assignment,” she said. “Like college. You fail to answer, you get an F and I make you do it again.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I fished out two tens, Marvin Uliaks’s tens, and handed them to her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You should read "), _c('em', [_vm._v("Fool’s Love,”")]), _vm._v(" she said as I moved toward the door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I did.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“When?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A long time ago,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _vm._v("“You read it as a boy. Read it as a man. You think it’s hot in here?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe, a little.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Monday?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Monday, same time?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes,” she said, moving to the thermostat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the small reception office, a woman—slim, long blond hair, well dressed, eyes down and covered with thick sunglasses—looked down. I walked past her and out into the sunshine.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c60927b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch02.vue
// module id = 87
// module chunks = 0